import React from "react";
import startCase from "lodash/startCase";
const TitleCell = ({ type }) => /* @__PURE__ */ React.createElement(React.Fragment, null, startCase(type));
export default TitleCell;
